// Google Analytics tracking helper functions
import {
  trackStoreOpenGA4,
  trackStoreWebsiteVisitGA4,
  trackProductViewGA4,
  trackGetDirectionsGA4,
  trackProductSearchGA4
} from './reactGaSetup';

// Simple wrapper functions - no more duplicate gtag fallback
export function trackStoreOpen(store) {
  // Only use ReactGA4 implementation - no duplicates
  trackStoreOpenGA4(store);
}

export function trackStoreWebsiteVisit(store, type) {
  // Only use ReactGA4 implementation - no duplicates
  trackStoreWebsiteVisitGA4(store, type);
}

export function trackProductView(product, store, canonicalProduct) {
  // Only use ReactGA4 implementation - no duplicates
  trackProductViewGA4(product, store, canonicalProduct);
}

export function trackGetDirections(store) {
  // Only use ReactGA4 implementation - no duplicates
  trackGetDirectionsGA4(store);
}

// Product search tracking - simplified without source parameter
export function trackProductSearch(searchParams) {
  // Only use ReactGA4 implementation - no duplicates
  return trackProductSearchGA4(searchParams);
}


// Track product details view (when user clicks on product to see store inventory)
// This is now consolidated with store modal open event but includes product context
export function trackProductDetails(product, store) {
  if (!product || !store) return false;
  
  // Use the store open tracking but include the product that led to this action
  const enhancedStore = {
    ...store,
    fields: {
      ...store.fields,
      // Add product context to the store data
      _triggerProduct: {
        name: product.name || product.displayName,
        canonicalName: product.canonicalName || '',
        id: product.id
      }
    }
  };
  
  trackStoreOpen(enhancedStore);
  return true;
}